<div class="max-w-[1442px] mx-auto py-14 ">
  <div class="px-3 lg:max-w-[1080px] flex flex-col justify-center mx-auto">
    <div class="flex flex-col  justify-center items-center gap-3 ">
      <h2 class="text-[#00DF9A] max-w-[625px] mt-9 text-center  text-[27px] leading-[33px] lg:text-[47px] lg:leading-[57px] font-semibold">FAQ’s</h2>
      <!-- <p class="text-white font-normal !text-[16px] text-center leading-5 max-w-[459px]">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et d</p> -->
    </div>
  </div>
</div>